import type {VotingSystem} from './ballotTypes';

export const formatShare = (share: number): string => `${Math.round(share * 100)}%`;

// Results always count in votes, whatever the system: a dot or a tick is one vote.
export const unitFor = (n: number): string => `${n} ${n === 1 ? 'vote' : 'votes'}`;

export const statLine = (row: {count: number | null; share: number | null}): string | null => {
    const parts = [
        ...(row.count !== null ? [unitFor(row.count)] : []),
        ...(row.share !== null ? [formatShare(row.share)] : []),
    ];
    return parts.length > 0 ? parts.join(' / ') : null;
};

export const SYSTEM_LABEL: Record<VotingSystem, string> = {
    fptp: 'First past the post',
    preferential: 'Preferential',
    dots: 'Dot voting',
    approval: 'Approval',
};
